import React, { useState, useEffect, useRef } from 'react';
import { 
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Button,
  Label,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';

import { constants } from '../../types/constants';
import { PRIVILEGE } from '../../types/privileges'
import { connect } from 'react-redux';
import { editVente } from '../../flux/actions/venteActions';
import { getNotaires } from '../../flux/actions/notaireActions';
import { IVenteNotaireEdit, IAuthReduxProps, ITarget } from '../../types/interfaces';
import Select from 'react-select';
import LoadingPage from '../../pages/loading';
import Loading from '../Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faBuilding, faHashtag, faHouseDamage, faLayerGroup, faMoneyBill, faMoneyBillAlt, faRulerCombined, faThLarge, faCompass, faMap, faQuestionCircle, faSquare, faCheckSquare, faSearch, faBookmark, faMapMarkerAlt, faSignature, faFolder, faFileInvoice, faReceipt, faFileContract, faFilePdf, faSync, faCloudUploadAlt, faHandRock, faTimes, faSpinner, faCheckCircle, faInfoCircle, faPercent, faPen, faCalendarAlt, faFileImage, faBookOpen, faPrint, faFileDownload, faPencilRuler } from '@fortawesome/free-solid-svg-icons'
import { useHistory, useLocation } from 'react-router-dom';
import { useAlert } from "react-alert";
import ReactTooltip from 'react-tooltip';
import moment from "moment";
import PDFLink, { PreviewBase64, printBase64, downloadBase64, instantUploadToFTP, printBuffer } from '../pdf/PDFLink';

import DatePicker from "reactstrap-date-picker";

const VenteNotaireEditComponent = ({ 
  modal,
  setModal,
  modalData,
  editVente,
  societeId,
  auth
 }: IVenteNotaireEdit) => {
  const alert = useAlert();
  const history = useHistory();

  const [chezNotaireValue, setChezNotaire] = useState(false);
  const [chezNotaireDateValue, setChezNotaireDate] = useState<any>(undefined);
  const [signatureValue, setSignature] = useState(false);
  const [enCoursDateValue, setEnCoursDate] = useState<any>(undefined);
  const [signeValue, setSigne] = useState(false);
  const [notaireDateValue, setNotaireDate] = useState<any>(undefined);
  const [expeditionDate, setExpeditionDate] = useState<any>(undefined);
  const [minuteDate, setMinuteDate] = useState<any>(undefined);
  const [disableChezNotaire, setDisableChezNotaire] = useState(true);
  const [disableSigne, setDisableSigne] = useState(true);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);

  const [notaires, setNotaires] = useState<any[]>([])
  const [notaireValue, setNotaireValue] = useState<any>('');
  const notaireOptions = notaires.map(e => ({value: e, label: e.name}));
  const [notairesLoading, setNotairesLoading] = useState(false)

  const editVenteHandleToggle = () => setModal(!modal);

  useEffect(() => {
    setNotaires([])
    if(societeId){
      setNotairesLoading(true)
      getNotaires(societeId).then(e => setNotaires((e || []).filter(e => !!e.notaire_societes?.find(t => t.societeId == societeId)))).finally(() => setNotairesLoading(false))
    }
  }, [societeId])

  useEffect(() => {
    if(!notaireValue && modalData["notaireId"])
      setNotaireValue(notaireOptions.find(e => e.value?.id === Number(modalData["notaireId"] || 0))?.value || '')
  }, [notaires?.length])

  const modalClosedHandle = () => {
    // setModalData('');
    setNotaireValue('');
    setChezNotaire(false);
    setChezNotaireDate(undefined);
    setSignature(false);
    setEnCoursDate(undefined);
    setSigne(false);
    setDisableChezNotaire(true);
    setDisableSigne(true);
    setNotaireDate(undefined);
    setExpeditionDate(undefined);
    setMinuteDate(undefined);
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const modalOpenedHandle = () => {
    if(modalData && modalData !== ''){
      setChezNotaire(modalData["chez_notaire"] === 1);
      setChezNotaireDate(modalData["chez_notaire_date"] || undefined);
      setSignature(modalData["en_cours_signature"] === 1);
      setEnCoursDate(modalData["en_cours_signature_date"] || undefined);
      setSigne(modalData?.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE);
      setNotaireDate(modalData?.bien?.signe_notaire_date || undefined);
      setDisableChezNotaire(modalData?.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE || !!modalData?.en_cours_signature);
      setDisableSigne(modalData?.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE);
      setNotaireValue(notaireOptions.find(e => e.value?.id === Number(modalData["notaireId"] || 0))?.value || '');
      setExpeditionDate(modalData?.dateExpedition || undefined);
      setMinuteDate(modalData?.dateMinute || undefined);
    }
  };

  const changeChezNotaireHandle = (e) => {
    setChezNotaire(e.target.checked);
  };
  const changeSignatureHandle = (e) => {
    setSignature(e.target.checked);
  };
  const chezNotaireDateChangeHandler = (e, t) => {
    setChezNotaireDate(e);
  };
  const enCoursDateChangeHandler = (e, t) => {
    setEnCoursDate(e);
  };

  const changeSigneHandle = (e) => {
    setSigne(e.target.checked);
  };
  const notaireDateChangeHandler = (e, t) => {
    setNotaireDate(e);
  };

  const focusHandler = (e) => {
    if(e.target.value == "0")
      e.target.select();
  };

  const callback = (success) => {
    if(success && !success.err){
      setReEnable(true);
      setModal(false);
      alert.success("Vente modifiée avec succès");
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const editHandle = async () => {
    if(!chezNotaireDateValue && chezNotaireValue){
      alert.error("Veuillez saisir la date signé client");
      return
    }
    if(!enCoursDateValue && signatureValue){
      alert.error("Veuillez saisir la date signature en cours");
      return
    }
    if(!notaireDateValue && signeValue){
      alert.error("Veuillez saisir la date passage notaire");
      return
    }
    if(!notaireValue && (chezNotaireValue || signatureValue || signeValue)){
      alert.error("Veuillez sélectionner un notaire");
      return
    }
    setDisableSubmit(true);
    editVente(modalData?.id || -1, notaireValue?.id || null, !auth?.user?.privileges?.includes(PRIVILEGE.NOTAIRE_EN_COURS) ? -1 : chezNotaireValue ? 1 : 0, chezNotaireDateValue && auth?.user?.privileges?.includes(PRIVILEGE.NOTAIRE_EN_COURS) ? new Date(chezNotaireDateValue) : null, !auth?.user?.privileges?.includes(PRIVILEGE.NOTAIRE_EN_COURS) ? -1 : signatureValue ? 1 : 0, enCoursDateValue && auth?.user?.privileges?.includes(PRIVILEGE.NOTAIRE_EN_COURS) ? new Date(enCoursDateValue) : null, !auth?.user?.privileges?.includes(PRIVILEGE.SIGNE_NOTAIRE) ? -1 : signeValue ? 1 : 0, !auth?.user?.privileges?.includes(PRIVILEGE.SIGNE_NOTAIRE) ? null : new Date(notaireDateValue), expeditionDate ? new Date(expeditionDate) : null, minuteDate ? new Date(minuteDate) : null, auth?.user?.id, callback);
  };

  useEffect(() => console.log({expeditionDate}), [expeditionDate])

  return <Modal isOpen={modal} toggle={editVenteHandleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle}>
    <ModalHeader toggle={editVenteHandleToggle}><FontAwesomeIcon icon={faSignature} />&nbsp;&nbsp;Modification des signatures</ModalHeader>
    <ModalBody>
        <Container className="linesConfirmationContainer">
          {!!auth?.user?.privileges?.includes(PRIVILEGE.NOTAIRE_EN_COURS) && <Row>
            <Col xs="12">
              <FormGroup className="formCustomSwitch text-center">
                <Label for="notaire">Nom du notaire</Label>
                <Select
                  name="notaire"
                  className="reactselect"
                  classNamePrefix="react-select"
                  value={notaireValue ? {label: notaireValue["name"], value: notaireValue} : null}
                  onChange={e => setNotaireValue(e?.value || '')}
                  placeholder={'Chercher par nom...'}
                  isClearable={false}
                  isLoading={notairesLoading}
                  loadingMessage={() => 'Chargement...'}
                  noOptionsMessage={() => 'pas de resultat'}
                  isSearchable={true}
                  options={notaireOptions}
                  menuContainerStyle={{ zIndex: 9999999 }}
                />
              </FormGroup>
            </Col>
          </Row>}
          {!!auth?.user?.privileges?.includes(PRIVILEGE.NOTAIRE_EN_COURS) && <Row>
            <Col xs="12">
              <FormGroup className="formCustomSwitch text-center">
                <Label for="chezNotaire">Signé client</Label>
                <CustomInput type="switch" id="chezNotaire" name="chezNotaireSwitch" disabled={disableChezNotaire} checked={chezNotaireValue} onChange={changeChezNotaireHandle} />
              </FormGroup>
            </Col>
          </Row>}
          {!!(auth?.user?.privileges?.includes(PRIVILEGE.NOTAIRE_EN_COURS) && chezNotaireValue) && <Row>
            <Col xs="12">
              <FormGroup>
                <Label for="chezNotaireDate">Date signé client</Label>
                <DatePicker id="chezNotaireDate"
                  value={chezNotaireDateValue}
                  dateFormat={constants.DP_DATE_FORMAT}
                  dayLabels={constants.DP_DAYS}
                  monthLabels={constants.DP_MONTHS}
                  weekStartsOn={constants.DP_WEEK_START}
                  onChange={(v,f) => chezNotaireDateChangeHandler(v, f)} />
              </FormGroup>
            </Col>
          </Row>}
          {!!auth?.user?.privileges?.includes(PRIVILEGE.NOTAIRE_EN_COURS) && <Row>
            <Col xs="12">
              <FormGroup className="formCustomSwitch text-center">
                <Label for="signature">Signature en cours</Label>
                <CustomInput type="switch" id="signature" name="signatureSwitch" disabled={disableSigne} checked={signatureValue} onChange={changeSignatureHandle} />
              </FormGroup>
            </Col>
          </Row>}
          {!!(auth?.user?.privileges?.includes(PRIVILEGE.NOTAIRE_EN_COURS) && signatureValue) && <Row>
            <Col xs="12">
              <FormGroup>
                <Label for="enCoursDate">Date signature en cours</Label>
                <DatePicker id="enCoursDate"
                  value={enCoursDateValue}
                  dateFormat={constants.DP_DATE_FORMAT}
                  dayLabels={constants.DP_DAYS}
                  monthLabels={constants.DP_MONTHS}
                  weekStartsOn={constants.DP_WEEK_START}
                  onChange={(v,f) => enCoursDateChangeHandler(v, f)} />
              </FormGroup>
            </Col>
          </Row>}
          {!!auth?.user?.privileges?.includes(PRIVILEGE.SIGNE_NOTAIRE) && <Row>
            <Col xs="12">
              <FormGroup className="formCustomSwitch text-center">
                <Label for="signe">Signé par le notaire</Label>
                <CustomInput type="switch" id="signe" name="signeSwitch" checked={signeValue} onChange={changeSigneHandle} />
              </FormGroup>
            </Col>
          </Row>}
          {!!(auth?.user?.privileges?.includes(PRIVILEGE.SIGNE_NOTAIRE) && signeValue) && <Row>
            <Col xs="12">
              <FormGroup>
                <Label for="notaireDate">Date passage notaire</Label>
                <DatePicker id="notaireDate"
                  value={notaireDateValue}
                  dateFormat={constants.DP_DATE_FORMAT}
                  dayLabels={constants.DP_DAYS}
                  monthLabels={constants.DP_MONTHS}
                  weekStartsOn={constants.DP_WEEK_START}
                  onChange={(v,f) => notaireDateChangeHandler(v, f)} />
              </FormGroup>
            </Col>
          </Row>}
          {/* {!!((auth?.user?.privileges?.includes(PRIVILEGE.EXPEDITION_MINUTE) || auth?.user?.privileges?.includes(PRIVILEGE.ENREGISTREMENT_MINUTE)) && signeValue) && <Row>
            hhh
          </Row>} */}
          {!!signeValue && <Row>
            <Col xs="12">
              <FormGroup>
                <Label for="expeditionDate">Date envoi minute au notaire</Label>
                <DatePicker id="expeditionDate"
                  value={expeditionDate}
                  dateFormat={constants.DP_DATE_FORMAT}
                  dayLabels={constants.DP_DAYS}
                  monthLabels={constants.DP_MONTHS}
                  weekStartsOn={constants.DP_WEEK_START}
                  disabled={!auth?.user?.privileges?.includes(PRIVILEGE.EXPEDITION_MINUTE)}
                  onChange={e => {
                    setExpeditionDate(e)
                    if(!e) setMinuteDate(undefined)
                  }} />
              </FormGroup>
            </Col>
          </Row>}
          {!!signeValue && <Row>
            <Col xs="12">
              <FormGroup>
                <Label for="minuteDate">Date enregistrement minute</Label>
                <DatePicker id="minuteDate"
                  value={minuteDate}
                  dateFormat={constants.DP_DATE_FORMAT}
                  dayLabels={constants.DP_DAYS}
                  monthLabels={constants.DP_MONTHS}
                  weekStartsOn={constants.DP_WEEK_START}
                  disabled={!expeditionDate || !auth?.user?.privileges?.includes(PRIVILEGE.ENREGISTREMENT_MINUTE)}
                  onChange={e => setMinuteDate(e)} />
              </FormGroup>
            </Col>
          </Row>}
          <Row className="justify-content-center stickyBottom">
            <Button
              className="btn btn-success linesConfirmationBtn"
              onClick={editHandle}
              disabled={disableSubmit}
              ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Modifier</Button>
          </Row>
        </Container>
    </ModalBody>
  </Modal>
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { editVente })(VenteNotaireEditComponent);
